import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SiteProvider } from "./contexts/site-context";
import App from "./App";

import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";

import "./index.scss";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SiteProvider>
      <App />
    </SiteProvider>
    <NotificationContainer />
  </BrowserRouter>
);

reportWebVitals();
